import { Component, OnInit, Injectable, HostListener } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { CommunicationService } from '../../../common/services/Communication.service';
import { dataModel, Industries } from '../../../models/data.model';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

@Component({
  selector: 'app-industries',
  templateUrl: './industries.component.html',
  styleUrls: ['./industries.component.sass'],
  animations: [
    trigger('fadeInOut', [
      state('void', style({
        opacity: 0
      })),
      transition('void <=> *', animate(2000)),
    ]),
  ]
})

export class IndustriesComponent implements OnInit {
  data: dataModel;
  currentIdustry: Industries;
  id: string;
  login = false;
  public screenSize: any;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.screenSize = window.innerWidth;
  }

  constructor(communicationService: CommunicationService, private route: ActivatedRoute,    private router: Router,
    ) {
      this.screenSize = window.innerWidth;
      this.data = communicationService.data;
  }
  example() {

            this.router.navigate([`/${this.currentIdustry['routers']}` + '/'+ 'example-case-study' ]);
          }
 
  
  ngOnInit() {
     this.data.industries.forEach(el => {
      if (el.routers === this.route.snapshot.params.id) {
        this.currentIdustry = el;
      }
    });
  }

}

